import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-userCenter4",
  "use": "icon-userCenter4-usage",
  "viewBox": "0 0 44 44",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 44 44\" id=\"icon-userCenter4\"><g fill=\"none\" fill-rule=\"evenodd\"><path stroke=\"#062337\" stroke-width=\"3\" d=\"M2 5v28.365L22 41l20-7.635V5l-19.97 5.719z\" /><path fill=\"#2F54EB\" fill-rule=\"nonzero\" d=\"M8.149 18.472v4.338l13.38 6.235 14.404-6.214v-4.36l-14.347 6.18z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol